export default "__VITE_ASSET__8a422dfb__"